import { useDemoState } from "@/state/demoState";
import React from "react";
import { WallKey } from "@/state/RoomConfig/RoomConfig";
import { Color } from "three";
import { Section } from "@/dom/components/Panel/Section";
import { Row } from "@/dom/components/Panel/Row";
import { ColorSelect } from "@/dom/components/ColorSelect/ColorSelect";
import { ROOM_COLOR_SELECTOR_PALETTE } from "@/utils/colors";

type WallStyleSectionProps = {
    wallKey: WallKey;
};

export const WallStyleSection: React.FC<WallStyleSectionProps> = ({ wallKey }) => {
    const roomConfig = useDemoState((state) => state.roomConfig);
    const setRoomConfig = useDemoState((state) => state.setRoomConfig);

    const wall = roomConfig[wallKey];

    const handleColorChange = (color: Color) => {
        setRoomConfig({ ...roomConfig, [wallKey]: { ...wall, color } });
    };

    const handleBaseboardColorChange = (color: Color) => {
        setRoomConfig({ ...roomConfig, [wallKey]: { ...wall, baseboardColor: color } });
    };

    return (
        <Section title="Стиль">
            <Row>
                <span>Цвет</span>
                <ColorSelect
                    selection={[wall.color]}
                    colors={ROOM_COLOR_SELECTOR_PALETTE}
                    onChange={handleColorChange}
                />
            </Row>
            <Row>
                <span>Плинтус</span>
                <ColorSelect
                    selection={[wall.baseboardColor]}
                    colors={ROOM_COLOR_SELECTOR_PALETTE}
                    onChange={handleBaseboardColorChange}
                />
            </Row>
        </Section>
    );
};
